import React, { Component } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import { defaultTo, toPairs, isEmpty } from 'ramda';
import { MdArrowForward, MdArrowBack } from 'react-icons/lib/md';
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

import { apiSearchData, apiSearchUsers } from '../../api/user';
import layoutActions from '../../redux/layout';
import { handleErrorBase } from '../../util/forms';

import Card from '../Card/index';
import EditField from '../Forms/EditField';
import UserCard from '../UserCard';
import Checkbox from '../Forms/Checkbox';
import ContactModal from '../Modal/ContactModal';

const mapDispatch = {
  ...layoutActions,
};
class FindUser extends Component {
  static propTypes = {
    professional: PropTypes.bool,
    member: PropTypes.bool,
    showLoader: PropTypes.func,
  };

  initialZip;
  initialState;
  initialVirtual;

  constructor(props) {
    super(props);
    const queryParams = queryString.parse(props.location.search);
    const zip = queryParams.state ? null : queryParams.zip;

    this.state = {
      users: [],
      currentPage: 1,
      totalPages: 1,
      totalResults: 0,
      currentFilter: [],
      certifications: [],
      areasOfExpertise: [],
      areasOfWork: [],
      searchState: zip ? false : true,
      showModal: false,
      userToContact: null,
    };
    this.initialState = defaultTo('', queryParams.state);
    this.initialZip = defaultTo('', zip);
    this.initialVirtual = queryParams.virtual ? 'offer_virtual_counseling' : '';
  }

  async componentDidMount() {
    let filter = [];

    if (!isEmpty(this.initialState)) {
      filter = toPairs({ state: this.initialState });
    } else if (!isEmpty(this.initialZip)) {
      const geocodedZip = await this.geocodeZip(this.initialZip);
      if (geocodedZip) {
        filter = toPairs({ coords: geocodedZip });
      }
    }

    if (this.initialVirtual) {
      filter.push(['offer_virtual_counseling', true]);
    }

    apiSearchData()
      .then(({ data }) => this.setState({ ...data }))
      .then(() => this.getSearchPage(filter, this.state.page))
      .then(() => this.setState({ currentFilter: filter }));
  }

  getSearchPage = (filter, page) => {
    const { member } = this.props;

    return apiSearchUsers({ filtered: filter, page, member })
      .then(({ data }) =>
        this.setState({
          users: data.data,
          currentFilter: filter,
          currentPage: data.currentPage,
          totalPages: data.lastPage,
          totalResults: data.total,
        }),
      )
      .then(() => window.scrollTo(0, 0))
      .catch((err) => handleErrorBase('No results, try a more general search'));
  };

  async geocodeZip(zip, radius = 25) {
    try {
      this.props.showLoader();
      const results = await geocodeByAddress(zip.toString());
      const { lat, lng } = await getLatLng(results[0]);
      return [lat, lng, defaultTo(25, radius)];
    } catch (err) {
      console.log(err);
    }
  }

  renderSidebar = () => {
    const { professional, member } = this.props;
    const { searchState } = this.state;

    return (
      <Formik
        isInitialValid
        initialValues={{
          name: '',
          state: this.initialState,
          zip: this.initialZip,
          location: '',
          radius: '',
          organization: '',
          jobTitle: '',
          offerings: this.initialVirtual,
        }}
        onSubmit={async (payload, formProps) => {
          const submission = { ...payload };
          if (submission.zip) {
            submission.coords = await this.geocodeZip(submission.zip, submission.radius);
            submission.zip = '';
          }
          submission.radius = '';

          this.getSearchPage(toPairs(submission), 1).then(() => formProps.setSubmitting(false));
        }}
      >
        {({
          values,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          isValid,
          setFieldValue,
          setValues,
          status,
        }) => (
          <form>
            <Card>
              <Card.Header>
                Filter {professional ? 'Professionals ' : member ? 'Members ' : ''}
                By
              </Card.Header>
              <Card.Body>
                <label className="font-weight-bold">Contact Information</label>
                <EditField
                  block
                  placeholder="Name"
                  name="name"
                  status={status}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.name}
                />
                {member && (
                  <EditField
                    block
                    placeholder="Email"
                    name="email"
                    status={status}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.email}
                  />
                )}
                {searchState ? (
                  <EditField
                    as={Select}
                    bare
                    block
                    simpleValue
                    className="mb-0"
                    placeholder="State"
                    name="state"
                    status={status}
                    onChange={(value) => setFieldValue('state', value)}
                    onBlur={handleBlur}
                    value={values.state}
                    options={[
                      { value: 'AA', label: 'Armed Forces Americas' },
                      { value: 'AP', label: 'Armed Forces Pacific' },
                      { value: 'AE', label: 'Armed Forces Others' },
                      { value: 'AL', label: 'Alabama' },
                      { value: 'AK', label: 'Alaska' },
                      { value: 'AZ', label: 'Arizona' },
                      { value: 'AR', label: 'Arkansas' },
                      { value: 'CA', label: 'California' },
                      { value: 'CO', label: 'Colorado' },
                      { value: 'CT', label: 'Connecticut' },
                      { value: 'DE', label: 'Delaware' },
                      { value: 'DC', label: 'District Of Columbia' },
                      { value: 'FL', label: 'Florida' },
                      { value: 'GA', label: 'Georgia' },
                      { value: 'HI', label: 'Hawaii' },
                      { value: 'ID', label: 'Idaho' },
                      { value: 'IL', label: 'Illinois' },
                      { value: 'IN', label: 'Indiana' },
                      { value: 'IA', label: 'Iowa' },
                      { value: 'KS', label: 'Kansas' },
                      { value: 'KY', label: 'Kentucky' },
                      { value: 'LA', label: 'Louisiana' },
                      { value: 'ME', label: 'Maine' },
                      { value: 'MD', label: 'Maryland' },
                      { value: 'MA', label: 'Massachusetts' },
                      { value: 'MI', label: 'Michigan' },
                      { value: 'MN', label: 'Minnesota' },
                      { value: 'MS', label: 'Mississippi' },
                      { value: 'MO', label: 'Missouri' },
                      { value: 'MT', label: 'Montana' },
                      { value: 'NE', label: 'Nebraska' },
                      { value: 'NV', label: 'Nevada' },
                      { value: 'NH', label: 'New Hampshire' },
                      { value: 'NJ', label: 'New Jersey' },
                      { value: 'NM', label: 'New Mexico' },
                      { value: 'NY', label: 'New York' },
                      { value: 'NC', label: 'North Carolina' },
                      { value: 'ND', label: 'North Dakota' },
                      { value: 'OH', label: 'Ohio' },
                      { value: 'OK', label: 'Oklahoma' },
                      { value: 'OR', label: 'Oregon' },
                      { value: 'PA', label: 'Pennsylvania' },
                      { value: 'RI', label: 'Rhode Island' },
                      { value: 'SC', label: 'South Carolina' },
                      { value: 'SD', label: 'South Dakota' },
                      { value: 'TN', label: 'Tennessee' },
                      { value: 'TX', label: 'Texas' },
                      { value: 'UT', label: 'Utah' },
                      { value: 'VT', label: 'Vermont' },
                      { value: 'VA', label: 'Virginia' },
                      { value: 'WA', label: 'Washington' },
                      { value: 'WV', label: 'West Virginia' },
                      { value: 'WI', label: 'Wisconsin' },
                      { value: 'WY', label: 'Wyoming' },
                    ]}
                  />
                ) : (
                  <div className="row">
                    <div className="col-md-6">
                      <EditField
                        block
                        className="mb-0"
                        type="number"
                        placeholder="Zip Code"
                        name="zip"
                        status={status}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.zip}
                      />
                    </div>
                    <div className="col-md-6">
                      <EditField
                        as={Select}
                        bare
                        block
                        simpleValue
                        className="mb-0"
                        placeholder="Search Radius"
                        name="radius"
                        status={status}
                        onChange={(value) => setFieldValue('radius', value)}
                        onBlur={handleBlur}
                        value={values.radius}
                        options={[
                          { value: 25, label: '25 miles' },
                          { value: 50, label: '50 miles' },
                          { value: 100, label: '100 miles' },
                        ]}
                      />
                    </div>
                  </div>
                )}

                <div className="d-flex justify-content-end">
                  <button
                    type="button"
                    className="btn btn-link btn-sm"
                    onClick={() => {
                      this.setState({ searchState: !searchState });
                      setValues({ ...values, radius: '', zip: '', state: '' });
                    }}
                  >
                    {searchState ? 'Search By Zip' : 'Search By State'}
                  </button>
                </div>

                <Checkbox
                  name="virtual_outside"
                  label="Include virtual counselors outside of my location search"
                  checked={values.virtual_outside}
                  onChange={handleChange}
                />

                <label className="font-weight-bold mt-3">Professional Details</label>
                <EditField
                  as={Select}
                  bare
                  block
                  multi
                  placeholder="Certifications"
                  name="certifications"
                  onChange={(value) =>
                    setFieldValue(
                      'certifications',
                      value.map((choice) => choice.value),
                    )
                  }
                  value={values.certifications}
                  options={this.state.certifications.map((certification) => ({
                    value: certification.id,
                    label: certification.name,
                  }))}
                />
                <EditField
                  as={Select}
                  bare
                  block
                  multi
                  placeholder="Areas of Expertise"
                  name="expertise"
                  onChange={(value) =>
                    setFieldValue(
                      'expertise',
                      value.map((choice) => choice.value),
                    )
                  }
                  value={values.expertise}
                  options={this.state.areasOfExpertise.map((area) => ({ value: area.id, label: area.name }))}
                />
                {member && (
                  <EditField
                    as={Select}
                    bare
                    block
                    multi
                    placeholder="Areas of Work"
                    name="work"
                    onChange={(value) =>
                      setFieldValue(
                        'work',
                        value.map((choice) => choice.value),
                      )
                    }
                    value={values.work}
                    options={this.state.areasOfWork.map((area) => ({ value: area.id, label: area.name }))}
                  />
                )}
                <EditField
                  block
                  placeholder="Organization"
                  name="organization"
                  status={status}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.organization}
                />
                <EditField
                  block
                  placeholder="Job Title"
                  name="jobTitle"
                  status={status}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.jobTitle}
                />
                {professional && (
                  <EditField
                    as={Select}
                    bare
                    block
                    multi
                    placeholder="Offerings"
                    name="offerings"
                    status={status}
                    onChange={(value) =>
                      setFieldValue(
                        'offerings',
                        value.map((choice) => choice.value),
                      )
                    }
                    onBlur={handleBlur}
                    value={values.offerings}
                    options={[
                      { value: 'offer_virtual_counseling', label: 'Offers virtual counseling' },
                      { value: 'offer_local_counseling', label: 'Offers Local counseling' },
                      { value: 'offer_group_workshops', label: 'Offers group workshops' },
                    ]}
                  />
                )}
                {member && (
                  <Checkbox
                    name="registeredForSymposium"
                    label="Registered for this year's symposium"
                    checked={values.registeredForSymposium}
                    onChange={handleChange}
                  />
                )}
                <button
                  type="submit"
                  className="btn btn-primary btn-block btn-not-round mt-3"
                  disabled={!isValid || isSubmitting}
                  onClick={handleSubmit}
                >
                  Search
                </button>
              </Card.Body>
            </Card>
          </form>
        )}
      </Formik>
    );
  };

  render() {
    const { professional, member } = this.props;
    const { users, currentPage, currentFilter, totalPages, totalResults, userToContact, showModal } = this.state;

    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-3 mb-5">{this.renderSidebar()}</div>
          {users.length > 0 ? (
            <div className="col-md-9">
              <h4 className="text-right">
                Page {currentPage} of {totalPages} ({totalResults} results)
              </h4>
              {users.map((user) => (
                <UserCard
                  key={user.id}
                  user={user}
                  onContact={() => this.setState({ showModal: true, userToContact: user })}
                  isSearch
                  showMembership={member}
                />
              ))}
              <Card className="flex-row">
                <button
                  disabled={currentPage <= 1}
                  className="d-flex align-items-center btn btn-primary btn-not-round"
                  onClick={() => this.getSearchPage(currentFilter, currentPage - 1)}
                >
                  <MdArrowBack /> Previous
                </button>
                <div className="flex-grow-1 d-flex align-items-center justify-content-center bold-blue-heading">
                  Page {currentPage} of {totalPages}
                </div>
                <button
                  disabled={currentPage >= totalPages}
                  className="d-flex align-items-center btn btn-primary btn-not-round"
                  onClick={() => this.getSearchPage(currentFilter, currentPage + 1)}
                >
                  Next <MdArrowForward />
                </button>
              </Card>
            </div>
          ) : (
            <div className="col-md-9">
              <Card>
                <Card.Header>No results.</Card.Header>
                <Card.Body>Please try a more general search.</Card.Body>
              </Card>
            </div>
          )}
        </div>
        <ContactModal
          user={userToContact}
          show={showModal}
          onHide={() => this.setState({ showModal: false, userToContact: null })}
        />
      </div>
    );
  }
}

export default withRouter(connect(null, mapDispatch)(FindUser));
